module.exports = __webpack_public_path__ + "img/a8_01.29009e48.jpg";